var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkCard',{attrs:{"image":_vm.thumbnail,"title":_vm.$path('name', _vm.value),"subtitle":_vm.subtitle,"to":_vm.$attrs.to,"is-list":_vm.isList}})
}
var staticRenderFns = []

export { render, staticRenderFns }